import React from 'react';
import { Zap, Shield, BarChart3, Clock } from 'lucide-react';

/**
 * ValuePropositions - Why Use SelfDrive section
 * Displays key benefits of using the platform
 */
const ValuePropositions = () => {
  const benefits = [
    {
      icon: Zap,
      title: 'Book in Seconds',
      description: 'No awkward phone calls! Just tap, pick a time, and you\'re all set.',
      color: 'text-customer-accent',
      bgGradient: 'from-customer-accent-light to-white'
    },
    {
      icon: Shield,
      title: 'Dealers You Can Trust',
      description: 'Every dealership is verified and reviewed by real drivers like you.',
      color: 'text-customer-teal',
      bgGradient: 'from-customer-teal-light to-white'
    },
    {
      icon: BarChart3,
      title: 'Know Before You Go',
      description: 'See all the details upfront - no surprises, just excitement!',
      color: 'text-customer-yellow hover:text-customer-yellow-hover',
      bgGradient: 'from-customer-yellow-light to-white'
    },
    {
      icon: Clock,
      title: 'Your Schedule, Your Way',
      description: 'Morning, noon, or weekend - pick whatever time works best for you.',
      color: 'text-customer-teal',
      bgGradient: 'from-customer-teal-light to-white'
    }
  ];

  return (
    <section className="py-12 lg:py-16 customer-friendly">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-app-text-light dark:text-app-text mb-4">
            Why You'll Love SelfDrive
          </h2>
          <p className="text-lg text-app-text-secondary-light dark:text-app-text-secondary max-w-2xl mx-auto">
            We made finding and test driving cars actually fun!
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="bg-white dark:bg-app-bg-secondary rounded-3xl border border-app-border-light/50 dark:border-app-border p-6 hover:border-customer-teal/30 transition-all duration-300 hover:shadow-xl hover:shadow-customer-teal/10 hover:-translate-y-1 group"
              >
                {/* Icon */}
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${benefit.bgGradient} dark:from-app-bg-tertiary dark:to-app-bg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className={`w-7 h-7 ${benefit.color}`} />
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold text-app-text-light dark:text-app-text mb-2">
                  {benefit.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-app-text-secondary-light dark:text-app-text-secondary leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuePropositions;
